export default {
  editTitle: 'Edit Plan',
  newTitle: 'New Plan',
  save: 'Save',
  create: 'Create',
  name: 'Name',
  startDate: 'Start date',
  endDate: 'End date',
  weekly: 'Weekly',
  weeklyDisabledForTemplate: 'Frequency is locked to the granularity of the template\'s source data.',
  weekDefinition: 'Week Definition',
  weekDefinitionInfo1: 'Weeks start on Mondays.',
  weekDefinitionInfo2: 'Weeks are represented by the date of their last day (Sunday).',
  weekDefinitionInfo3: 'Even if only a single day of a given week is contained between Start Date and End Date, that week will be considered in the plan.',
  weekDefinitionInfo4: 'So when your End Date falls mid-week, the last column is dated after it: it is the Sunday that closes the week your End Date belongs to.',
  ok: 'Ok',
  nameRequired: 'Name is required',
  dateRequired: 'Date is required',
  mustBeAfterStartDate: 'Must be after start date'
}
